import {Tag, Text} from "@blueprintjs/core";
import {CSSProperties, useContext, useMemo} from "react";
import {IndicatorColors} from "../settings/ColorSettings/ColorizedIndicators/ColorizedIndicators";
import {PreferenceContext, extractSimplePref} from "../../providers/PreferenceProvider";
import {ServiceTypeColorType} from "../settings/ColorSettings/ServiceTypeColor/ServiceTypeColor";
import {TenantPreferences} from "../../constants/constants";

type ServiceBadgeProps = {
  service: string | undefined;
  hideTitle?: boolean;
  ellipsize?: boolean;
  textStyle?: CSSProperties;
  tagStyle?: CSSProperties;
};

export const ServiceBadge = ({service, ellipsize, tagStyle, textStyle, hideTitle = false}: ServiceBadgeProps) => {
  const {tenantPreferences} = useContext(PreferenceContext);

  const serviceTypeColorData: ServiceTypeColorType[] = useMemo(() => {
    return extractSimplePref(tenantPreferences, TenantPreferences.serviceTypeColor, []).value as ServiceTypeColorType[];
  }, [tenantPreferences]);

  if (!service) {
    return <span />;
  }

  const backGroundColor = serviceTypeColorData.find((sv) => sv.name === service)?.color;

  const style: CSSProperties = {
    ...tagStyle,
    color: backGroundColor ? "#FFFFFF" : "#828282",
    backgroundColor: backGroundColor ? IndicatorColors[backGroundColor].hex : "#E5E6E6",
    borderRadius: "4px",
    fontWeight: 500
  };
  return (
    <Tag minimal style={style}>
      <Text ellipsize={ellipsize} title={hideTitle ? "" : service} style={textStyle}>
        {service}
      </Text>
    </Tag>
  );
};
